import React from "react";
import { Dialog } from "primereact/dialog";
import { useThemeColors } from "../hooks/useThemeColors";

interface ThemeModalProps {
  visible: boolean;
  onHide: () => void;
  theme: string;
  provider: string;
}

export const ThemeModal: React.FC<ThemeModalProps> = ({
  visible,
  onHide,
  theme,
  provider,
}) => {
  const colors = useThemeColors(theme);

  return (
    <Dialog
      header={`Colores del Theme - ${provider}`}
      visible={visible}
      style={{ width: "70vw", maxWidth: "800px" }}
      onHide={onHide}
    >
      <div className="p-4">
        {colors.length === 0 ? (
          <div className="text-center p-4">
            <i className="pi pi-info-circle text-blue-500 text-4xl mb-3"></i>
            <p className="text-gray-600">No se encontraron colores válidos en este theme</p>
            <small className="text-gray-500">
              Los colores deben estar en formato hexadecimal (#RRGGBB)
            </small>
          </div>
        ) : (
          <div className="grid">
            <div className="col-12 mb-3">
              <h4 className="text-lg font-semibold text-gray-800 mb-2">
                <i className="pi pi-palette mr-2"></i>
                Colores encontrados ({colors.length})
              </h4>
              <p className="text-sm text-gray-600">
                Los siguientes colores están definidos en el theme:
              </p>
            </div>
            {colors.map((color, index) => (
              <div key={index} className="col-12 md:col-6 lg:col-4 mb-3">
                <div 
                  className="surface-card p-3 shadow-1 border-round border-1 surface-border"
                  style={{ transition: 'all 0.3s ease' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                  }}
                >
                  <div className="flex align-items-center gap-3">
                    <div 
                      className="border-round border-2 surface-border"
                      style={{ 
                        backgroundColor: color.value,
                        width: '40px',
                        height: '40px',
                        minWidth: '40px',
                        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
                      }}
                    ></div>
                    <div className="flex-1">
                      <div className="font-medium text-900 text-sm mb-1">
                        {color.name}
                      </div>
                      <div className="text-xs text-600 font-mono">
                        {color.value}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Dialog>
  );
}; 